// TODO: refactor jQuery --> ES
import {request} from './HttpClient.js';

export default class AsyncContentLoader {
	constructor(app) {
		this.app = app;

		this.lazyload()
		this.loadContent();
	}

	/**
	 * Lazy load sections via AJAX.
	 */
	loadContent() {
		const self = this;
		document.querySelectorAll('.js-load-content:not(.js-loaded)').forEach(elem => {
			if (!elem.dataset.url) return;

			const params = elem.dataset.params ? JSON.parse(elem.dataset.params) : null;
			request(elem.dataset.url, {
				params,
			})
				.then(async req => {
					elem.innerHTML = await req.text();
					elem.classList.add('js-loaded');
					elem.dispatchEvent(new CustomEvent('load', {detail: {request: req}}));
					self.lazyload();
					app.iconLoader.loadSvgs();
					app.cookieManager._handleConsent();
					app.elements.initCarousel();
				});
		})
	}

	/**
	 * Postload Images
	 */
	lazyload() {
		$("img").each(function (i, v) {
			if ($(this).data("src") && !$(this).parent().hasClass('fluid-picture')) {
				$(this).attr("src", $(this).data("src"));
			}
		});
		$(".js-postload-img").each(function (i, val) {
			if ($(this).data("src")) {
				$(this).css("background-image", 'url(' + $(this).data("src") + ')');
			}
		});
	}
}
